import Song from "./Song";

// private class variables
let SongManager_currentSong;
let SongManager_songIndex;

class SongManager {
  // this takes a filepath and loads a song from it, making it the currentSong
  static loadSong = songFile => {
    var song = new Song();
    song.readFromCsvFile(songFile, x => {
      SongManager_currentSong = song;
      // after the file is loaded save the song object
      // Keyboard.expectKey(song.currentNote());
    });
  };

  static getSongUrlFromId = songId => {
    if (!SongManager_songIndex || songId === "twinkle") {
      return window.PUBLIC_URL + "/songs/twinkle/TwinkleTwinkle.csv";
    }
    let entry = SongManager_songIndex.contents[songId];
    return entry ? window.PUBLIC_URL + entry.filename : null;
  };

  static loadSongIndex = filename => {
    fetch(window.PUBLIC_URL + filename)
      .then(response => response.json())
      .then(index => {
        SongManager_songIndex = index;
        console.log("song index loaded");
        console.log(index);
      })
      .catch(error => console.log("load song index error: ", error));
  };

  static get currentSong() {
    return SongManager_currentSong;
  }
  // static set currentSong(song) {  SongManager_currentSong = song; }
  static get songIndex() {
    return SongManager_songIndex;
  }
}

export default SongManager;



// WEBPACK FOOTER //
// ./src/SongManager.js